<form [formGroup]="form" class="support-block-step">
  <p class="support-block-intro">{{ introText }}</p>
  <p class="support-block-note" *ngIf="noteText">{{ noteText }}</p>

  <app-tile-group
    [control]="form.controls.block"
    [options]="blockOptions"
    [label]="selectLabel"
  />

  <app-quantity-stepper
    *ngIf="showConditionalFields"
    [control]="form.controls.packs"
    [label]="packsLabel"
  />

  <app-pill-choice
    *ngIf="showConditionalFields"
    [control]="form.controls.joiningLsl"
    [label]="joiningLslLabel"
    [required]="true"
    [errorText]="
      'SERVICE_PLAN.VALIDATION.SUPPORT_BLOCK_JOINING_LSL_REQUIRED' | translate
    "
  />

  <app-textarea
    *ngIf="showConditionalFields"
    [control]="form.controls.timing"
    [label]="timingLabel"
    [required]="false"
  />
</form>
